import classNames from 'classnames';
import Image from 'next/image';

import styles from './InfoArea.module.scss';

const InfoArea = ({ data }) => {
  return (
    <section
      id='info-area'
      className={classNames(styles.container, 'wrapper section')}
      itemScope
      itemType='https://schema.org/Article'
    >
      <div className={classNames(styles.imageContainer, 'card')}>
        <Image
          alt={data?.title}
          title={data?.title}
          src={data?.image}
          width={670}
          height={504}
        />
      </div>
      <div className={classNames(styles.decription, 'card')}>
        <h4>{data?.title}</h4>
        <p>{data?.description}</p>
      </div>
    </section>
  );
};

export default InfoArea;
